import { axiosRequest } from '@/util/axios-request';

// SorKorLor 3 月度列表
export var getWelfareFundMonthList = function getWelfareFundMonthList(params) {
  return axiosRequest({
    url: '/web/welfare_fund/getMonthList',
    method: 'GET',
    params: params
  });
};

// SorKorLor 3 异步导出
export var exportWelfareFund = function exportWelfareFund(data) {
  return axiosRequest({
    url: '/web/welfare_fund/export',
    method: 'POST',
    data: data
  });
};